<template>
  <div>
    <div
      v-for="(dayOfWeek, dayIndex) in openingHours"
      :key="dayIndex"
      class="vx-row">
      <div class="vx-col w-full flex justify-between items-center">
        <label>{{ $t(`$DaysOfWeek.${dayOfWeek.day}`) }}</label>
        <i v-if="dayOfWeek.open" class="fas fa-store text-2xl"></i>
        <i v-else class="fas fa-store-alt-slash text-2xl"></i>
      </div>

      <template v-if="dayOfWeek.open">
        <div
          v-for="(slot, slotIndex) in dayOfWeek.slots"
          :key="slotIndex"
          class="vx-col flex items-center w-full md:w-2/3 mt-3">
          <span class="px-1 md:px-3">
            {{ get12HoursTime(slot.openingTime) }} - {{ get12HoursTime(slot.closingTime) }}
          </span>
        </div>
      </template>

      <div
        class="vx-col w-full"
        v-else>
        <small class="font-light">{{ $t('Closed') }}</small>
      </div>

      <vs-divider/>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'HostedWaitingListFormOpeningHours',
  props: {
    openingHours: {
      type: Array,
      required: true,
    },
  },
  methods: {
    get12HoursTime(time) {
      return moment(time, 'HH:mm').format('hh:mm A');
    },
  },
};
</script>

<style scoped lang="scss">

</style>
